import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./menu_cover_promo_link_type.js";
//#region src/menu_cover_promo_link_type_helper.ts
var menu_cover_promo_link_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(linkType) {
	switch (linkType) {
		case "no-link": return "No Link";
		case "menu-item": return "Menu Item";
		case "menu-page": return "Menu Page";
		case "menu-section": return "Menu Section";
	}
}
//#endregion
export { menu_cover_promo_link_type_helper_exports, name };

//# sourceMappingURL=menu_cover_promo_link_type_helper.js.map